import React from "react"
import PropTypes from "prop-types"

const statusToCSSClass = status => {
  switch (status) {
    case "error":
      return "warning"
    case "info":
      return "info"
    case "success":
      return "success"
    default:
      return ""
  }
}

class FlashMessage extends React.Component {
  render() {
    const isHidden = !this.props.text
    const className = `alert alert-${statusToCSSClass(this.props.status)} ${isHidden ? "hidden" : ""}`
    return (
      <div className={className}>{this.props.text}</div>
    )
  }
}

FlashMessage.propTypes = {
  onClose: PropTypes.func,
  status: PropTypes.string,
  text: PropTypes.string
}

export default FlashMessage
